import { Image } from "@mui/icons-material";
import { Typography, Divider } from "@mui/material";

function Footer() {

    return (
    <>
        <Divider sx={{ mb: 2 }} />

        <Typography fontSize="small" sx={{ my: 5, mx: 1 }}>
        <img
            src="/morningstar.png"
            width="80"
            height="20"
            alt="Morningstar Logo"
            style={{ verticalAlign: "middle", marginRight: 8 }}
        />
        Morningstar provides financial statement and stock market pricing data to FSA Valuation Service Inc. for QuickFINANCIAL and related products.
        © {new Date().getFullYear()} FSA Valuation Service Inc. and Morningstar, Inc. All Rights Reserved. The QuickFINANCIAL model and the data contained herein: 
        (1) is the proprietary to FSA Valuation Service Inc., Morningstar and/or its content providers; (2) is not warranted to be accurate, complete or timely. FSA,
        Morningstar or its content providers are not responsible for any damages or losses arising from any use of this information. 
        Past performance is no guarantee of future results.
        </Typography>
    </>
    );
}

export default Footer;